import React, { Component } from "react";
import cx from "classnames";
//
import { intervention } from "../utils";
import Icon from "./Icon";

class Carousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idx: props.initialIndex,
      loading: false,
    };
  }

  prevClicked(ev) {
    ev.stopPropagation();

    this.updateIndex(-1);
  }

  onNext(ev) {
    ev.stopPropagation();

    this.updateIndex(1);
  }

  updateIndex(dir) {
    const { images } = this.props;
    const maxIndex = images.length - 1;
    let idx = this.state.idx + dir;

    if (idx < 0) idx = maxIndex;

    if (idx > maxIndex) idx = 0;

    this.setState({
      idx,
      loading: true,
    });
  }

  onImageLoad() {
    this.setState({
      loading: false,
    });
  }

  render() {
    const { images, isPremium, hash } = this.props;
    const { idx, loading } = this.state;
    const image = images[idx];

    return (
      <div className={cx("carousel", { "carousel--loading": loading })}>
        <img
          className="carousel__image"
          // src={`/escorts/${hash}/images/md/${image.path}`}
          src={`/images/md/${image.path}`}
          onLoad={(ev) => this.onImageLoad()}
        />
        {images.length > 1 && (
          <Icon
            name="keyboard_arrow_left"
            className="icon-prev"
            large
            onClick={(ev) => this.prevClicked(ev)}
          />
        )}
        {images.length > 1 && (
          <Icon
            name="keyboard_arrow_right"
            className="icon-next"
            large
            onClick={(ev) => this.onNext(ev)}
          />
        )}
        {isPremium && image.verified === 1 && (
          <small className="ribbon-tag">
            Verified Photo
            <Icon name="check" small />
          </small>
        )}
      </div>
    );
  }
}

Carousel.defaultProps = {
  initialIndex: 0,
};

export default Carousel;
